import {Inject, Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Data, RouterStateSnapshot} from '@angular/router';
import {AuthService, UserPermissions} from 'app/core/services/auth.service';
import {environment} from 'src/environments/environment';
import {REDIRECT_TO_LEGACY_LOGIN} from '../core/helpers/redirect';
import {RouterHelperService} from 'app/core/services/router-helper.service';

export interface PermissionsGuardData extends Data {
    permission: keyof UserPermissions;
    redirectToHome?: boolean;
}

@Injectable()
export class PermissionsGuard {
    constructor(
        private auth: AuthService,
        @Inject(REDIRECT_TO_LEGACY_LOGIN) public redirectToHome: () => void,
        public nav: RouterHelperService
    ) {}

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        /* istanbul ignore next */
        if (!next.data.permission && !environment.production) {
            console.warn(`[PermissionsGuard] 'permission' is required in route data `);
        }

        if (!this.hasPermission(next.data.permission)) {
            console.debug(`[PermissionsGuard] '${next.data.permission}' access is forbidden `);
            if (next.data.redirectToHome === true) {
                this.redirectToHome();
                return false;
            } else {
                this.nav.navigateToNotFound();
                return true;
            }
        }
        return true;
    }

    hasPermission(permission: keyof UserPermissions) {
        const user = this.auth.getCurrentUserLastValue();
        if (user) {
            return user.permissions[permission];
        }
        return false;
    }
}
